import { XMarkIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { FC } from 'react';

interface RosterFilterSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
}

const RosterFilterSidebar: FC<RosterFilterSidebarProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  return (
    <>
      {/* Overlay */}
      <button
        type="button"
        aria-label="Close sidebar"
        className={classNames(
          'fixed inset-0 bg-black bg-opacity-50 transition-opacity z-40',
          {
            'opacity-100': isOpen,
            'opacity-0 pointer-events-none': !isOpen,
          },
        )}
        onClick={onClose}
      />

      {/* Sidebar */}
      <div
        className={classNames(
          'fixed top-0 right-0 h-full w-full sm:max-w-[31rem] bg-gray-50 shadow-lg transform transition-transform duration-300 ease-in-out z-50',
          {
            'translate-x-0': isOpen,
            'translate-x-full': !isOpen,
          },
        )}
      >
        <div className="flex items-center justify-between  p-4">
          <h2 className="text-lg font-semibold">Filters</h2>
          <button
            onClick={onClose}
            className="rounded-full p-1 hover:bg-gray-100"
            aria-label="Close filters sidebar"
          >
            <XMarkIcon className="size-6" />
          </button>
        </div>
        <div className="mx-4 h-[calc(100vh-5rem)] overflow-y-auto border-t py-5 scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-gray-300 hover:scrollbar-thumb-gray-400">
          {children}
        </div>
      </div>

      {/* Portal target for dropdowns */}
      <div id="roster-filter-portal" className="fixed left-0 top-0 z-[9999]" />
    </>
  );
};

export default RosterFilterSidebar;
